import * as yup from "yup";

const SalaryIMSSSchema = yup.object({
  salaryIMSS: yup.number().required("Campo requerido")
});

export default SalaryIMSSSchema;
